import { composeIO } from 'react-compose-io'
import { lancamentoNaoAssociadoIO } from './LancamentoNaoAssociado.IO'
import { LancamentoNaoAssociadoView } from './LancamentoNaoAssociado.View'

export const LancamentoNaoAssociado = composeIO(LancamentoNaoAssociadoView, lancamentoNaoAssociadoIO)
